/* eslint-disable @typescript-eslint/naming-convention */
import { ref } from 'vue-demi';
import { CampaignObjectiveType } from './../../enums/tt4b/index';
import request from './../../utils/request/index';
import apis from './../../const/apis';
import { DraftType } from './../../const/common';

export type ObjectiveType = {
  objectiveType: CampaignObjectiveType; // 后端 key -> objective_type
};
const objectiveType = ref<ObjectiveType>({
  objectiveType: CampaignObjectiveType.TRAFFIC,
});

function setObjective(type: CampaignObjectiveType): void {
  objectiveType.value.objectiveType = type;
}

export default {
  objectiveType,
  setObjective,
};

export const getDraft = async (): Promise<any> =>
  await request.get(apis.adgroup.get_draft, {
    draft_type: DraftType.fastcreation,
  });
